"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

/*
 * Dedicated for Sentry purposes;
 * https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/#report-react-component-render-errors
 * */
function GlobalError({ error }: { error: NextError }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="pl">
      <body>
        <NextError statusCode={null as never} />
      </body>
    </html>
  );
}

export default GlobalError;
